
// @ts-nocheck
declare var gGDPR_logoURL: string;

declare var gGDPR_privacyPolicyURL: string;

import { Emit, Component, Prop, Vue } from "vue-facing-decorator";
import SensitiveDataList from './SensitiveDataList.vue';
import ConsentItem from './ConsentItem.vue';

import { UsVa as UsVaV1 } from '@iabgpp/cmpapi'; 
import { updateCMPVirginia } from './updateCMPFuncs.js'

@Component({
  components: {
    SensitiveDataList,
    ConsentItem
  },
  props: {
    cmpApi: Object,
  },  

})

export default class LayerStateVirginia extends Vue {

	privacyPageURL = "";
  forcedFixedPosition = false;
  logo_URL = typeof gGDPR_logoURL  == "string" ? gGDPR_logoURL : "";

  consentToSharing = true;
  consentToTargeting = true;
  sectionName = UsVaV1.NAME
  sectionID = UsVaV1.ID
  dirty = false

	mounted(): void {
    console.log("Virginia Mounted");
    this.privacyPageURL = typeof gGDPR_privacyPolicyURL  == "string" ? gGDPR_privacyPolicyURL : "";

    if ( this.cmpApi.hasSection( this.sectionName ) ) {
          this.consentToSharing = this.cmpApi.getFieldValue(this.sectionName, 'SaleOptOut' ) == 2  ? true : false;
          this.consentToTargeting = this.cmpApi.getFieldValue(this.sectionName, 'TargetedAdvertisingOptOut') == 2  ? true : false;
        }
      else  {
		updateCMPVirginia( true, this.cmpApi, this.consentToSharing, this.consentToTargeting )
      }
	}

  sensitiveDataChange( consentArray: any ) {
    console.log("LayerStateVirginia: sensitiveDataChange(): event=", consentArray);
    this.dirty = true;
  } 


  @Emit('changeViewEvent')
	saveSettingsClick( consentToAll : Boolean ): string {
    if ( consentToAll)  {
      this.consentToSharing = true;
      this.consentToTargeting = true;
    }
    
    		updateCMPVirginia( consentToAll, this.cmpApi, this.consentToSharing, this.consentToTargeting );
    this.cmpApi.fireEvent( "sectionChanged", this.sectionName);
    return 'close'
	}
  
}
